import Vue from 'vue';
import VueRouter from 'vue-router';
import { navigationGuard } from '@/plugins/auth';

Vue.use(VueRouter);
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};

const routes = [
  {
    path: '/registration',
    name: 'callback',
    meta: { requiresAuth: false },
    component: (r) =>
      require(['@/views/main/registration/registration_layouts.vue'], r),
    children: [
      {
        path: 'welcome/:teamId/:registrationTemplateId',
        name: 'callback',
        meta: { title: 'global.text21', requiresAuth: false },
        component: (r) =>
          require(['@/views/main/registration/components/WelcomeStep.vue'], r),
        props: { module: 'registration' }
      },
      {
        path: 'guide/:teamId/:registrationTemplateId/:formId',
        name: 'callback',
        meta: { title: 'global.text21', requiresAuth: false },
        component: (r) =>
          require(['@/views/main/registration/registration_guide.vue'], r)
      },
      {
        path: 'form/:teamId/:registrationTemplateId/:formId',
        name: 'callback',
        meta: { title: 'global.text21', requiresAuth: false },
        component: (r) =>
          require(['@/views/main/registration/registration_form.vue'], r)
      },
      {
        path: 'attachment/:teamId/:registrationTemplateId/:formId',
        name: 'callback',
        meta: { title: 'global.text22', requiresAuth: false },
        component: (r) =>
          require([
            '@/views/main/registration/components/AttachmentStep.vue'
          ], r),
        props: { module: 'registration' }
      },
      {
        path: 'success',
        name: 'callback',
        meta: { title: 'global.text21', requiresAuth: false },
        component: (r) =>
          require(['@/views/main/registration/components/SuccessStep.vue'], r)
      }
    ]
  },
  {
    path: '/recruitment',
    name: 'recruitment',
    component: (r) => require(['@/views/main/recruitment/layout.vue'], r),
    children: [
      {
        path: 'welcome/:teamId/:registrationTemplateId',
        name: 'callback',
        meta: { title: 'global.jobApplicationForm' },
        component: (r) =>
          require(['@/views/main/registration/components/WelcomeStep.vue'], r),
        props: { module: 'recruitment' }
      },
      {
        path: 'form/:teamId/:registrationTemplateId/:formId',
        name: 'callback',
        meta: { title: 'global.jobApplicationForm' },
        component: (r) => require(['@/views/main/recruitment/form.vue'], r)
      },
      {
        path: 'attachment/:teamId/:registrationTemplateId/:formId',
        name: 'callback',
        meta: { title: 'global.text22_2' },
        component: (r) =>
          require([
            '@/views/main/registration/components/AttachmentStep.vue'
          ], r),
        props: { module: 'recruitment' }
      },
      {
        path: 'success',
        name: 'callback',
        meta: { title: 'global.jobApplicationForm' },
        component: (r) =>
          require(['@/views/main/registration/components/SuccessStep.vue'], r)
      }
    ]
  },
  {
    path: '/improveEmployeeFiles',
    name: 'callback',
    component: (r) => require(['@/views/main/archives/layout.vue'], r),
    meta: { title: 'global.text21', requiresAuth: false },
    children: [
      {
        path: 'form/:teamId',
        name: 'callback',
        meta: { title: 'global.text21', requiresAuth: false },
        component: (r) => require(['@/views/main/archives/archives.vue'], r)
      },
      {
        path: 'attachment/:teamId/:formId',
        name: 'callback',
        meta: { title: 'global.text22', requiresAuth: false },
        component: (r) => require(['@/views/main/archives/attachment.vue'], r)
      },
      {
        path: 'success',
        name: 'callback',
        meta: { title: 'global.text21', requiresAuth: false },
        component: (r) => require(['@/views/main/archives/success.vue'], r)
      }
    ]
  },
  /* {
    path: '/improveEmployeeFiles/:teamId/',
    name: 'callback',
    component: () => import('@/views/main/archives/archives.vue'),
  }, */
  {
    path: '/fileExisted',
    name: 'callback',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/views/main/archives/existed.vue')
  },
  {
    path: '/payroll/verify-password',
    name: 'callback',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/views/main/verify-payroll-password/index.vue')
  },
  {
    // 独立文件预览页，供 app / h5 webview 直接打开：
    // /file-viewer?files=<encodeURIComponent(JSON.stringify([{url,name}]))>&index=0
    path: '/file-viewer',
    name: 'callback',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/views/main/file-viewer/index.vue')
  },
  {
    path: '/',
    component: () => import('@/views/layouts/layouts.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/main/dashboard/dashboard.vue'),
        meta: { title: 'global.selfservice', requiresAuth: true }
      },
      {
        path: 'approver',
        component: () => import('@/views/main/main_layouts.vue'),
        meta: { title: 'approval.text', requiresAuth: true },
        children: [
          {
            path: 'list',
            component: () => import('@/views/main/approver/approver_list.vue'),
            meta: { title: 'approval.text', requiresAuth: true },
            name: 'approver'
          },
          {
            path: ':id/form',
            name: 'approver',
            component: () => import('@/views/main/approver/approver_form.vue'),
            meta: { title: 'approval.text', requiresAuth: true }
          }
        ]
      },
      {
        path: 'announcements',
        component: () => import('@/views/main/main_layouts.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: 'list',
            component: () =>
              import('@/views/main/announcements/announcements_list.vue'),
            meta: { title: 'announcement.text', requiresAuth: true },
            name: 'announcement.name'
          },
          {
            path: ':id/show',
            component: () =>
              import('@/views/main/announcements/announcements_show.vue'),
            meta: { title: 'announcement.text', requiresAuth: true },
            name: 'announcement.show'
          }
        ]
      },
      // 制度列表
      {
        path: 'policies',
        component: () => import('@/views/main/main_layouts.vue'),
        meta: { title: 'announcement.text5', requiresAuth: true },
        children: [
          {
            path: 'list',
            component: () => import('@/views/main/policies/policies_list.vue'),
            meta: { title: 'announcement.text5', requiresAuth: true },
            name: 'policies.list'
          },
          {
            path: ':id/show',
            component: () => import('@/views/main/policies/policies_show.vue'),
            meta: { title: 'announcement.text5', requiresAuth: true },
            name: 'policies.show'
          }
        ]
      },
      {
        path: 'calendar',
        component: () => import('@/views/main/calendar/layouts.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: 'leave',
            component: () => import('@/views/main/calendar/leave-calendar.vue'),
            meta: { title: 'global.leaveCalendar', requiresAuth: true },
            name: 'global.leaveCalendar'
          },
          {
            path: 'vacation',
            component: () => import('@/views/main/calendar/vacation.vue'),
            meta: { title: 'vacationDetail.vacation', requiresAuth: true },
            name: 'vacationDetail.vacation'
          }
        ]
      },
      {
        path: 'payroll',
        component: () => import('@/views/main/main_layouts.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: 'list',
            component: () => import('@/views/main/payroll/list.vue'),
            meta: { title: 'payroll.name', requiresAuth: true },
            name: 'payroll.name'
          }
        ]
      },
      {
        path: 'tax',
        component: () => import('@/views/main/main_layouts.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: 'list',
            component: () => import('@/views/main/tax/list.vue'),
            meta: { title: 'tax.name', requiresAuth: true },
            name: 'tax.name'
          }
        ]
      },
      {
        path: 'vacation',
        component: () => import('@/views/main/main_layouts.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: 'plans',
            component: () => import('@/views/main/vacation-plans/index.vue'),
            meta: { title: 'vacationPlans.label', requiresAuth: true },
            name: 'vacationPlans.label'
          }
        ]
      }
    ]
  },
  {
    path: '/transit',
    name: 'transit',
    component: (r) => require(['@/views/main/transit/index.vue'], r)
  },
  {
    path: '/approverError',
    name: 'ApproverError',
    component: (r) => require(['@/views/main/approver/approver_error.vue'], r)
  },
  {
    path: '/401',
    name: '401',
    component: (r) => require(['@/views/main/error-page/401.vue'], r),
    meta: { title: '401' }
  },
  {
    path: '/authorization-callback',
    name: 'callback',
    meta: {
      isCallback: true,
      requiresAuth: false
    },
    component: (r) =>
      require(['@/views/main/authorization-callback/index.vue'], r)
  },
  {
    path: '/interview',
    name: 'interview',
    meta: {
      requiresAuth: false
    },
    component: (r) => require(['@/views/main/interview/layout.vue'], r),
    children: [
      {
        path: 'signedQR/verify',
        name: 'callback',
        meta: {
          requiresAuth: false
        },
        component: (r) => require(['@/views/main/interview/verify.vue'], r)
      },
      {
        path: 'signedQR/checkIn',
        name: 'callback',
        meta: {
          requiresAuth: false
        },
        component: (r) => require(['@/views/main/interview/checkIn.vue'], r)
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(navigationGuard);

export default router;
